import { useEffect } from "react";
import { Application } from "../../System/Application/Application";

export function OpenLink(props) {
    const onClose = props.onCloseFunc || (() => {});

    const openLink = (link) => {
        window.open(link, "_blank");
        onClose();
    };

    useEffect(() => {
        const link = props.args.url || "https://www.example.com";
        openLink(link);
    }, []);

    if (props.language === "Fr") {
        return (
            <Application {...props}>
                <div className="hello-world-content">
                    <h2>Ouverture dans un nouvel onglet...</h2>
                </div>
            </Application>
        );
    }

    return (
        <Application {...props}>
            <div className="hello-world-content">
                <h2>Opening in a new tab...</h2>
            </div>
        </Application>
    );
}
